import React from 'react';
import { Icon } from './Icon.js';
export const IconBorderFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M15.25,2H2.75c-.414,0-.75,.336-.75,.75V15.25c0,.414,.336,.75,.75,.75H15.25c.414,0,.75-.336,.75-.75V2.75c0-.414-.336-.75-.75-.75Zm-.75,12.5H3.5V3.5H14.5V14.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "5.875", cy: "9", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "9", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "12.125", cy: "9", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "12.125", r: ".75", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "5.875", r: ".75", fill: "currentColor" })));
};
//# sourceMappingURL=IconBorderFill18.js.map